import { SizeProperty } from '@topcon/tuicl';
import {
  TeButton,
  TeButtonOutline,
  TeCheckbox,
  TeContainer,
  TeContainerSlim,
  TeIcon,
  TeText,
} from '@topcon/tuicl-react';
import { IconName } from '@topcon/tuicl/dist/components/icon/icon.utils';
import { ReactNode } from 'react';
import styled from 'styled-components';

import IconWrapper from './IconWrapper';

interface Props {
  onClick: () => void;
  icon: IconName;
  title: string;
  subtitle: string;
  active: boolean;
  padding?: SizeProperty;
  selectCtaType?: 'button' | 'checkbox';
  /** Extra content rendered under the subtitle, inside the card. */
  children?: ReactNode;
}

const renderSelectButton = (
  type: Props['selectCtaType'] = 'button',
  active: boolean,
  onClick: Props['onClick']
) => {
  if (type === 'button') {
    return active ? (
      <TeButton icon="check" size="s" rounded teclick={() => onClick()} />
    ) : (
      <TeButtonOutline text="Select customer" size="s" teclick={() => onClick()} />
    );
  }

  return <TeCheckbox checked={active} techange={onClick} style={{ alignSelf: 'flex-start' }} />;
};

const SelectableBusinessPartner = ({
  onClick,
  icon,
  title,
  subtitle,
  active,
  padding,
  selectCtaType,
  children,
}: Props) => {
  return (
    <Container
      fill
      grow
      gap="s"
      borderColor={active ? 'border.brand.primary' : 'background.primary'}
      borderRadius={4}
      backgroundColor={active ? 'background.selected' : 'background.primary'}
      padding={padding}
      justifyContent="space-between"
      alignItems="center"
    >
      <TeContainerSlim gap="s" fill grow>
        <IconWrapper>
          <TeIcon name={icon} size="l" />
        </IconWrapper>
        <TeContainerSlim fill grow column justifyContent="center" alignItems="flex-start" gap="xs2">
          <TeText weight={700} size={14}>
            {title}
          </TeText>
          <TeText weight={400} size={12} color="text.secondary">
            {subtitle}
          </TeText>
          {children}
        </TeContainerSlim>
      </TeContainerSlim>

      {renderSelectButton(selectCtaType, active, onClick)}
    </Container>
  );
};

const Container = styled(TeContainer)<{
  disabled?: boolean;
}>`
  width: 100% !important;
  opacity: ${(props) => (props.disabled === true ? 0.4 : 1)};
  cursor: ${(props) => (props.disabled === true ? 'not-allowed' : 'default')};
`;

export default SelectableBusinessPartner;
